import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SearchSidebar.css';
import httpService from '../services/HttpService'; // Import your HttpService (adjust path as needed)

const SearchSidebar = ({ isSearchOpen, toggleSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState({ result_images: [], result_data: [] });
    const [activeTab, setActiveTab] = useState('Women');
    const [categories, setCategories] = useState([]);
    const [expandedCategories, setExpandedCategories] = useState({});
    const [subCategories, setSubCategories] = useState({});

    const [loading, setLoading] = useState(false);
    const searchInputRef = useRef(null);
    const navigate = useNavigate();

    const clearSearch = (close = false) => {
        setSearchTerm("");
        setSearchResults({ result_images: [], result_data: [] });
        if(close) {
            toggleSearch();
        }
    };

    useEffect(() => {
        if (searchInputRef.current && isSearchOpen) {
            searchInputRef.current.focus();
        }
        const disableScroll = (e) => {
            const searchResults = document.querySelector(".search-results");
    
            if (searchResults && searchResults.contains(e.target)) {
                return;
            }
    
            e.preventDefault();
        };

        if (isSearchOpen) {
            document.body.style.overflow = 'hidden';
            document.addEventListener("touchmove", disableScroll, { passive: false });
        } else {
            document.body.style.overflow = '';
            document.removeEventListener("touchmove", disableScroll);
        }
        const delaySearch = setTimeout(() => {
            if (searchTerm) {
              fetchSearchResults(searchTerm);
            }
          }, 800);
      
        return () => {
            clearTimeout(delaySearch);
            document.removeEventListener("touchmove", disableScroll);
        };
    }, [isSearchOpen, searchTerm]);

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value.trim() === "") {
            setSearchResults({ result_images: [], result_data: [] });
            return;
        }
        setLoading(true);
        fetchSearchResults(value);
    };

    const fetchSearchResults = async (query) => {
        try {
            const response = await httpService.get(`/search?text=${encodeURIComponent(query)}`); // Use HttpService
            const data = await response.json();
            setSearchResults({
                result_images: data.result_images || [],
                result_data: data.result_data || [],
            });
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
        setLoading(false);
    };

    const fetchCategories = async () => {
        try {
            const response = await httpService.get('/categories'); // Use HttpService
            const res = await response.json();
            const rootCategories = res.filter(category => category.parent_id === null);
            setCategories(rootCategories);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchSubCategories = async (parentId) => {
        try {
            const response = await httpService.get(`/categories?parent_id=${parentId}`); // Use HttpService
            setSubCategories(prevState => ({
                ...prevState,
                [parentId]: response
            }));
        } catch (error) {
            console.error('Error fetching subcategories:', error);
        }
    };

    const handleCategoryClick = (categoryId) => {
        setExpandedCategories(prevState => {
            const newState = { ...prevState };
            if (newState[categoryId]) {
                delete newState[categoryId];
            } else {
                newState[categoryId] = true;
                fetchSubCategories(categoryId);
            }
            return newState;
        });
    };

    const getLinkPath = (item) => {
        const { type, id } = item;
        switch (type) {
            case 'model':
                return `/model/${id}`;
            case 'brand':
                return `/brand/${id}`;
            case 'product':
                return `/product/${id}`;
            case 'collection':
                return `/product?collection_id=${id}`;
            case 'category':
                return `/product?category_id=${id}`;
            default:
                return '#';
        }
    };

    return (
        <div className={`search-sidebar ${isSearchOpen ? "open" : ""}`}>
                <button
                    className="hamburger close"
                    onClick={() => clearSearch(true)}
                    aria-label="Toggle Navigation Menu"
                >
                    <span className="material-symbols-sharp">
                        {isSearchOpen ? 'close' : 'menu'}
                    </span>
                </button>
            {/*<h2 className="search-header">Search</h2>*/}
            <div className="search-sidebar-header">
                <form onSubmit={(e) => e.preventDefault()} className="search-form">
                    <div className="search-input-wrapper">
                        <span className="material-symbols-sharp">search</span>
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Search"
                            value={searchTerm}
                            ref={searchInputRef}
                            onChange={handleSearchChange}
                        />
                        {searchTerm && <span className="clear-icon" onClick={clearSearch}>✖</span>}
                    </div>
                </form>
            </div>
            <div className="search-results">
                {loading ? (
                    <div className="loader"></div>
                ) : (
                    <>
                        <div className="result-images-container">
                            <div className="result-images">
                                {searchResults.result_images.map((item, index) => (
                                    <a key={`${item.id}-${index}`} href={`/${item.type}/${item.id}`}>
                                        <img src={item.image} alt={item.name} className="result-image" />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {searchResults.result_data.length > 0 && (
                            <div className="result-section">
                                {searchResults.result_data.map((item, index) => (
                                    <div
                                        key={`${item.id}-${index}`}
                                        className="result-item"
                                        onClick={() => navigate(getLinkPath(item))}
                                    >
                                        {item.name} <span className="chevron">›</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        {searchTerm && searchResults.result_images.length === 0 && searchResults.result_data.length === 0 && (
                            <div className="no-results">Нет результатов</div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default SearchSidebar;